/**
 * When to call Kratos public endpoints used by MerchantProvider.
 * Both APIs return 400 if called with an empty query (no resolver params).
 *
 * - `merchant-apps`: needs at least one of tokenId, requestId, shopUrl, merchantId.
 * - `ui-attributes`: only cart / checkout / SSO (`context` set); same resolver rule.
 */

export type MerchantAppsResolverInput = {
  tokenId?: string | null;
  requestId: string;
  shopUrl: string;
  merchantId: string;
};

export const shouldFetchMerchantApps = (input: MerchantAppsResolverInput): boolean =>
  Boolean(input.tokenId || input.requestId || input.shopUrl || input.merchantId);

export type UiAttributesResolverInput = {
  /** `"CART"` | `"CHECKOUT"` | `"SSO"` from page; `null` for profile, wishlist, etc. */
  context: string | null;
  tokenId?: string | null;
  shopUrl: string;
  segmentId?: string | null;
  requestId: string;
  merchantId: string;
};

export const shouldFetchUiAttributes = (input: UiAttributesResolverInput): boolean => {
  if (!input.context) {
    return false;
  }
  return Boolean(
    input.tokenId || input.shopUrl || input.segmentId || input.requestId || input.merchantId,
  );
};
